import { BReactComponent } from 'blocks-cloud/b-react-component';
import app from 'Cloud/Application/app';
import { EditorHeader } from 'reactApp/ui/EditorHeader/EditorHeader';

export const updateEditorHeaderLicenseExpired = () => {
    const header = document.querySelector('#react-header');

    if (!header) {
        return;
    }

    const file = app.current();

    const reactHeader = new BReactComponent({
        ReactComponent: EditorHeader,
        renderMode: 'replace',
    });

    reactHeader.renderTo(header, {
        props: {
            isPublic: !!app.isPublic(),
            isStock: Boolean(app.isStock()),
            enableFavorites: !app.isPublic() && !app.isMountedOrSharedFolder(file).isMounted,
            licenseExpired: true,
        },
    });
};
